import { request } from "../request";
import { request2 } from "../request2";
import Cookies from "js-cookie";
import config from '../config'
export const getUserInfo = () => {
  return request({
    method: 'post',
    url: config.casURL + '/user/profile/get'
  }, {
    config: {
      baseURL: config.casURL
    }
  }).then(res => {
    return {
      jwt: Cookies.get(process.env.REACT_APP_TOKEN_KEY, { domain: process.env.REACT_APP_DOMAIN }),
      user: res
    }
  })
}

export const getAllUserList = (params) => {
  return request({
    method: 'post',
    url: config.casURL + '/user/page',
    params
  }, {
    config: {
      baseURL: config.casURL
    }
  })
}

export const setUserRole = (params) => {
  return request({
    method: 'post',
    url: config.casURL + '/admin/user-profile/set-role',
    params
  }, {
    config: {
      baseURL: config.casURL
    }
  })
}


export const setUserLanguage = (params) => {
  Cookies.set("language", params.language, {
    expires: 7,
    domain: process.env.REACT_APP_DOMAIN,
  });
  return request({
    method: 'post',
    url: config.casURL + '/user/language/modify',
    params
  }, {
    config: {
      baseURL: config.casURL
    }
  })
}
// 临时功能

export const uploadPrivateTransaction = (params, other) => {
  return request({
    method: 'post',
    url: '/private-transaction/upload',
    params,
    config: {
      formData: true
    },
    axiosConfig: {
      ...other
    }
  })
}
export const delPrivateTransactionList = (params) => {
  return request({
    method: 'post',
    url: '/private-transaction/remove',
    params
  })
}
export const getPrivateTransactionList = (params) => {
  return request({
    method: 'post',
    url: '/private-transaction/page',
    params
  })
}
export const loginAsUser = (params) => {
  return request({
    method: 'post',
    url: '/admin/login-as-user',
    params
  })
}

export const searchPortalUser = (userEmail) => {
	return request({
		method: 'post',
		url: '/admin/getUserByEmail',
		params:{userEmail}
	})
}

export const searchUser = (name) => {
	return request2({
		method: 'post',
		url: '/dashboard/user/search',
		params:{name}
	})
}
export const strictSearch = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/user/strictSearch',
		params
	})
}

export const updateProfileInfo = (params) => request({
  url: process.env.REACT_APP_CAS_API+'/admin/user-profile/modify',
  method: 'post',
  params
})
